const api = 'https://backend.tcode.online/api/'

export default api